import { useMemo } from 'react';

import { useQueryGetCartCheckout } from './useQueryGetCartCheckout';
import { useCartCheckoutToken } from './useCartCheckoutToken';

export const useQueryGetCartCount = () => {
  const { data, isPending, ...other } = useQueryGetCartCheckout();
  const [getCheckoutToken] = useCartCheckoutToken();
  const checkoutToken = getCheckoutToken();

  const count = useMemo(() => {
    if (!checkoutToken) {
      return 0;
    }

    if (data) {
      return data.line_items.reduce(
        (accumulator, productInCart) => accumulator + productInCart.quantity,
        0
      );
    }
    return null;
  }, [data, checkoutToken]);

  return {
    ...other,
    countIsLoading: checkoutToken ? isPending : false,
    count
  };
};
